// extracted by mini-css-extract-plugin
export var circle = "_l-2";
export var icon = "_l-a";
export var iconHighlight = "_l-0";
export var lg = "_l-8";
export var md = "_l-7";
export var outline = "_l-4";
export var sm = "_l-6";
export var square = "_l-1";
export var xl = "_l-9";
export var xs = "_l-5";
export var xxs = "_l-3";